import { defineRouting } from "next-intl/routing";
import sitecoreConfig from "sitecore.config";

export const SUPPORTED_LANGUAGES = [
  "en",
  "en-us",
  ...(process.env.ENABLED_LANGUAGES?.split(",").map((lang) => lang.trim()) ??
    []),
];

export const routing = defineRouting({
  locales: SUPPORTED_LANGUAGES,
  defaultLocale: sitecoreConfig.defaultLanguage,
  localePrefix: "always",
});
